import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { parentDialogIdForStepSelector } from '../selectors'

export const useDialogIdForStepId = (stepId: string) => {
  const selectorInstance = useMemo(() => parentDialogIdForStepSelector(stepId), [stepId])
  return useSelector(selectorInstance)
}

export default useDialogIdForStepId
